import BlogDetail from './components/blogDetail';
import { useParams } from 'react-router-dom';
import LinkButton from '../../global/components/LinkButton';


export default function BlogPostPage() {
    const { id } = useParams();

  return (
    <div className="pt-2 flex flex-col justify-center items-center">
        <BlogDetail id={id} />
        <LinkButton to='/blog' className="mx-5">
          View Other Blogs
        </LinkButton>
    </div>
  )
}
